module.exports = __webpack_public_path__ + "img/coinbankB29.b6be182e.jpg";